module.exports = __webpack_public_path__ + "static/media/cyber-border-right-bottom.22324895.svg";